module.exports = __webpack_public_path__ + "img/logo-kr.ba0727a4.png";